import { createContext, useState, useContext } from "react";

export const LoaderContext = createContext(0);
LoaderContext.displayName = "LoaderContext";

export const LoaderProvider = (props) => {
  const [loaderCount, setLoaderCount] = useState(0);

  return (
    <LoaderContext.Provider
      value={{
        loaderCount,
        setLoaderCount,
      }}
    >
      {props.children}
    </LoaderContext.Provider>
  );
};

export const useLoaderContext = () => useContext(LoaderContext);
